import { render } from "./TableRowPlusAfter.vue?vue&type=template&id=259bd86c"
import script from "./TableRowPlusAfter.vue?vue&type=script&lang=js"
export * from "./TableRowPlusAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableRowPlusAfter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "259bd86c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('259bd86c', __exports__)) {
    api.reload('259bd86c', __exports__)
  }
  
  module.hot.accept("./TableRowPlusAfter.vue?vue&type=template&id=259bd86c", () => {
    api.rerender('259bd86c', render)
  })

}


export default __exports__